// =============================================================================
// Core: Bundles
// =============================================================================

import _Base from './core--base';

const {_page, _library} = new _Base();
const {_array: libArray, _utils: libUtils} = _library;
const {$document} = _page;

export default (function (bundle) {
    const bundleObject = {
        storage: []
    };

    const events = [
        'on:Ready',
        'on:Resize',
        'on:ResizeEnd',
        'on:Scroll',
        'on:ScrollDefault',
        'on:BundleReady',
        'on:KendoUpdate',
        'on:PageUpdate',
        'on:TabChange',
        'on:UiUpdate',
        'on:AttachmentLoad',
        'on:CompanyChange',
        'on:RefreshScrollpoints'
    ];

    const compose = (f, g) => (...args) => f(g(...args));

    function compareValues(key, order = 'asc') {
        return function innerSort(a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                // property doesn't exist on either object
                return 0;
            }
            const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
            const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return order === 'desc' ? comparison * -1 : comparison;
        };
    }

    function addBundle(...fns) {
        return fns.reduce(compose);
    }

    function addBundleToStorage(bundleObject, bundle) {
        if (!bundle.hasOwnProperty('weight')) bundle.weight = 0;
        const updatedStorage = bundleObject.storage.concat(bundle);
        return {...bundleObject, storage: updatedStorage};
    }

    function mergeAdded(bundleComing) {
        return Object.assign(bundleObject, bundleComing);
    }

    function fire(obj) {
        const {storage} = obj;
        // array is sorted by name in ascending order
        const storageSorted = storage.sort(compareValues('weight'));

        // console.log(libUtils.leftPad(`Bundle Storage`), storage);
        storageSorted.forEach(function (bundle) {
            // console.log(libUtils.leftPad(`Bundle`), bundle);
            if (libArray.anyMatchInArray(events, bundle.event)) {
                bundle.event.map(e => $document.on(e, bundle.fn));
                // console.log(libUtils.leftPad(`${bundle.name} 💣Bundle`), bundle.weight);
            }
        });
    }

    return {
        add(bundle) {
            return addBundle(mergeAdded, addBundleToStorage)(bundleObject, bundle);
        },
        init() {
            fire(bundleObject);
            $.event.trigger('on:BundleReady');
        }
    };
})();
